import { render } from "./TestApplicants.vue?vue&type=template&id=39569507"
import script from "./TestApplicants.vue?vue&type=script&lang=js"
export * from "./TestApplicants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__